import { createAsyncThunk } from "@reduxjs/toolkit";

import { InternalAuthService } from "Auth/services";
import { IUserPatchData } from "Auth/types";
import { USER_ACTIONS } from "Bands/types";

export const getUser = createAsyncThunk(
  USER_ACTIONS.getUser,
  async (
    {
      userId,
    }: {
      userId: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const user = await InternalAuthService.getUser(userId);

      return user;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUser = createAsyncThunk(
  USER_ACTIONS.editUser,
  async (
    {
      userId,
      editUserData,
    }: {
      userId: string;
      editUserData: IUserPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      if (userId) {
        const editedUser = await InternalAuthService.editUser(userId, editUserData);

        return editedUser;
      }

      return null;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
